import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-forestDeep text-beige" data-id="element-88" data-mp="3gfsmscqd8umz">
      <div className="rule-gold h-2 w-full" aria-hidden="true" data-id="element-89" data-mp="3ggk6ap6ov1ww" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-90" data-mp="32onll67cnuaj">
        <p className="font-display text-lg font-extrabold uppercase text-cream" data-id="element-91" data-mp="36pftnw4hjt58">{productShortName}</p>
        <p className="mt-3 text-sm" data-id="element-92" data-mp="3uf0lz5mj42r6">Created by surveying specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-forestSoft pt-6 text-xs" data-id="element-93" data-mp="38qtcrvhxfo0">
          © 2026 {productShortName} — All rights reserved.
        </p>
      </div>
    </footer>;
}